module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYCAYAAADzoH0MAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAEKADAAQAAAABAAAAGAAAAAAn7RgJAAAAy0lEQVQ4Ee1Ruw3CMBD1BWcKOragYgJaRnAsWhgDGug8Ai0T0FIxAXtE+Rz3Iiwl2HGHhFBOOvnufc4XR6kpvvsCbO0cmbqFxkg2Jq+JbuA184qcq2LaLAYCa4hOMn2JRD2mCwawUlQbcxaD7ZksMHA9rCsDoDLmQEQ7Ya/MvIBK+qcca+mPuXN7YD6CDSjL7kJeZmW5EWeN7GrB3pz3jp9+1aooHkgoPfbpCjaAQL5L9MOIYVBEBwyt6W4a8AuPqFM/SbftNsX/CfcCkuo5LYxuMB0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/font_red.png
// module id = CRBm
// module chunks = 1